// A tick without changes must not save: saving posts logs, refetches the job and moves NEW to IN_PROGRESS.
// A shape drag/resize ends on mouseup, which the saving overlay cannot catch, so wait for the next tick.
export function shouldAutoSave(
    enabled: boolean,
    saving: boolean,
    hasUnsavedChanges: () => boolean,
    gestureInProgress = false,
): boolean {
    return enabled && !saving && !gestureInProgress && hasUnsavedChanges();
}
